export default {"src":"/_next/static/media/italy.69ac5f3b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};